// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2kBys","title":"Images45_title__1yQPu","images":"Images45_images__2JgU7"};